<div
	*ngIf="!addServiceMode"
	class="m-auto rounded-12px px-[48px] py-36px lg:max-w-[872px] bg-off-white max-smMobile:w-full max-mobile:px-padding-mobile-14"
>
	<!-- IMG SECTION  -->
	<div class="{{ !isEditMode ? 'mb-[24px]' : '' }}">
		<div
			[ngStyle]="{
				'background-image': this.packageData?.image
					? 'url(`./assets/images/empty state.jpg`)'
					: ''
			}"
			class="rounded-12px min-h-[365px] lg:min-w-[776px] max-smMobile:w-full relative background-img"
		>
			<div class="overlay rounded-12px"></div>
			<!-- Add overlay here -->

			<img
				class="w-full rounded-12px"
				onerror="'../../../../../assets/images/empty state.jpg'"
				[src]="
					this.packageData?.image
						? attachmentPath + this.packageData?.image
						: ''
				"
				alt=""
			/>

			<div
				class="absolute flex flex-col items-end justify-end p-12px bottom-0 right-0"
			>
				<button
					(click)="uploadImg()"
					class="rounded-6px bg-gradient py-[10px] px-[16px] mb-[6px]"
				>
					<img
						class="inline-block max-w-[22px]"
						src="./assets/images/add-white.svg"
						alt=""
					/>
					<p class="inline-block text-off-white my-0">
						{{
							packageData?.image
								? ('ACTIONS.CHANGE_IMAGES' | translate)
								: ('ACTIONS.ADD_IMG' | translate)
						}}
					</p>
				</button>
				<button
					(click)="deleteImg()"
					*ngIf="this.packageData?.image"
					class="rounded-6px border-off-white border-[1px] py-[10px] px-[16px]"
				>
					<img
						class="inline-block ltr:mr-[12px]"
						src="./assets/images/delete-white.svg"
						alt=""
					/>
					<p class="inline-block text-off-white my-0">
						{{ 'ACTIONS.DELETE_IMG' | translate }}
					</p>
				</button>
			</div>
		</div>
	</div>

	<!-- IMG SECTION  -->
	<!-- COUNTER SECTION  -->
	<!-- TIME LEFT  -->
	<div
		*ngIf="isEditMode && timeDifference > 0 && this.packageData?.endDate"
		class="rounded-[50px] bg-off-white py-12px px-[50px] flex boxhsadow max-w-[375px] max-mobile:max-w-[275] m-auto items-center justify-between -translate-y-[50%] max-mobile:-translate-y-[10px] max-mobile:px-padding-mobile-14"
	>
		<!-- TIME LEFT  -->

		<div class="flex flex-col items-center">
			<span
				class="text-dark-grey text-font-18 font-DIN-bold max-mobile:text-font-mobile-small"
			>
				{{ timeLeft?.days }}
			</span>
			<span class="text-dark-grey text-font-12">
				{{ 'PACKAGES.ADD_PACKAGE.DAYS' | translate }}
			</span>
		</div>
		<span
			class="text-gradient text-font-18 font-DIN-bold max-mobile:text-font-mobile-small"
			>:</span
		>
		<div class="flex flex-col items-center">
			<span
				class="text-dark-grey text-font-18 font-DIN-bold max-mobile:text-font-mobile-small"
			>
				{{ timeLeft?.hours }}
			</span>
			<span class="text-dark-grey text-font-12">
				{{ 'PACKAGES.ADD_PACKAGE.HOURS' | translate }}
			</span>
		</div>
		<span
			class="text-gradient text-font-18 font-DIN-bold max-mobile:text-font-mobile-small"
			>:</span
		>
		<div class="flex flex-col items-center">
			<span
				class="text-dark-grey text-font-18 font-DIN-bold max-mobile:text-font-mobile-small"
			>
				{{ timeLeft?.min }}
			</span>
			<span class="text-dark-grey text-font-12">
				{{ 'PACKAGES.ADD_PACKAGE.MINUTES' | translate }}
			</span>
		</div>
		<span
			class="text-gradient text-font-18 font-DIN-bold max-mobile:text-font-mobile-small"
			>:</span
		>
		<div class="flex flex-col items-center">
			<span
				class="text-dark-grey text-font-18 font-DIN-bold max-mobile:text-font-mobile-small"
			>
				{{ timeLeft?.sec }}
			</span>
			<span class="text-dark-grey text-font-12">
				{{ 'PACKAGES.ADD_PACKAGE.SECONDS' | translate }}
			</span>
		</div>
		<!-- TIME LEFT  -->
	</div>
	<!-- TIME LEFT  -->
	<!-- START AT  -->
	<div
		*ngIf="packageData?.startDate && !this.packageData?.endDate"
		class="rounded-[50px] bg-off-white py-12px px-[50px] flex flex-col boxhsadow max-w-[375px] max-mobile:max-w-[200px] max-mobile:px-padding-mobile-24 m-auto items-center justify-between -translate-y-[50%] max-mobile:-translate-y-[10px]"
	>
		<p
			class="text-center text-medium-gray text-font-14 font-DIN-Bold font-bold mb-[3px]"
		>
			{{ 'PACKAGES.ADD_PACKAGE.START_AT' | translate }}
		</p>
		<p class="text-font-18 font-DIN-bold font-bold text-gradient">
			{{ packageData?.startDate | date : 'dd/MM/yyyy' }}
		</p>

		<!-- START DATE -->
	</div>
	<!-- START AT  -->
	<!-- COUNTER SECTION  -->
	<!-- ACTIVATION SECTION  -->
	<div
		class="p-24px mb-24px bg-main-color-black rounded-12px boxhsadow max-mobile:p-12px {{
			timeDifference < 0 ? 'mt-5' : ''
		}}"
	>
		<!-- FIRST TOGGLE  -->
		<div class="flex justify-between items-center">
			<div>
				<p
					class="text-font-18 text-gradient font-DIN-bold mb-[6px] max-mobile:text-font-14"
				>
					{{ 'PACKAGES.ADD_PACKAGE.ACTIVATION_STATUS' | translate }}
				</p>
				<p class="text-font-14 text-light-grey max-mobile:text-font-12">
					{{ 'PACKAGES.ADD_PACKAGE.ABILITY_TO_ACTIVATE' | translate }}
				</p>
			</div>
			<div>
				<p
					class="inline-block m-0 align-top rtl:ml-[6px] ltr:mr-[6px] max-mobile:text-font-12 {{
						packageData?.isActive ? 'text-success-green' : 'text-[#F5F5F5]'
					}}"
				>
					{{
						packageData?.isActive
							? ('ACTIONS.ACTIVE' | translate)
							: ('ACTIONS.INACTIVE' | translate)
					}}
				</p>

				<mat-slide-toggle
					[checked]="packageData?.isActive"
					(change)="confirmAction('isActive', $event, packageData.isActive)"
					hideIcon
				></mat-slide-toggle>
			</div>
		</div>
		<!-- FIRST TOGGLE  -->

		<div *ngIf="packageData?.isActive">
			<!-- DIVIDER  -->
			<div class="w-full h-[1px] bg-[#383A47] my-[18px]"></div>
			<!-- DIVIDER  -->
			<!-- SECOND TOGGLE  -->
			<div
				class="flex justify-between items-center"
				*ngIf="packageData?.isActive"
			>
				<div>
					<p
						class="text-font-18 text-gradient font-DIN-bold mb-[6px] max-mobile:text-font-14"
					>
						{{ 'PACKAGES.ADD_PACKAGE.BOOKING_ABILITY' | translate }}
					</p>
					<p class="text-font-14 text-light-grey max-mobile:text-font-12">
						{{ 'PACKAGES.ADD_PACKAGE.CAN_BOOK_PACKAGE' | translate }}
					</p>
				</div>
				<div class="max-mobile:flex max-mobile:flex-col">
					<p
						class="inline-block m-0 align-top rtl:ml-[6px] ltr:mr-[6px] max-mobile:text-font-12 {{
							packageData?.canBook ? 'text-success-green' : 'text-[#F2B8B5]'
						}}"
					>
						{{
							packageData?.canBook
								? ('PACKAGES.ADD_PACKAGE.CAN_BOOK' | translate)
								: ('PACKAGES.ADD_PACKAGE.CANT_BOOK' | translate)
						}}
					</p>

					<mat-slide-toggle
						[checked]="packageData?.canBook"
						(change)="confirmAction('canBook', $event, packageData.canBook)"
						hideIcon
					></mat-slide-toggle>
				</div>
			</div>
		</div>
		<!-- SECOND TOGGLE  -->
	</div>
	<!-- ACTIVATION SECTION  -->
	<app-add-package-info
		[packageData]="packageData"
		[isEditMode]="isEditMode"
		(emitData)="updateForm($event)"
	></app-add-package-info>
	<!-- DURATION SECTION  -->
	<app-add-package-duration
		[packageData]="packageData"
		[isEditMode]="isEditMode"
		(emitData)="updateForm($event)"
	></app-add-package-duration>
	<!-- DURATION SECTION  -->

	<!-- <div
		*ngIf="!isEditMode && packageData?.services?.length"
		class="flex flex-row justify-between mt-[24px] py-2 min-h-[40px]"
	>
		<p class="text-dark-grey font-Poppins-bold text-font-16">
			{{ 'PACKAGES.SERVICES' | translate }}
		</p>

	</div> -->
	<app-add-view-package-service
		[packageData]="packageData"
		[isEditMode]="isEditMode"
		(addServiceMode)="addServiceMode = $event"
		[viewMode]="viewMode"
		(emitData)="updateForm($event)"
	></app-add-view-package-service>
	<!-- [disabled]="isFormValid.includes(false)" -->
	<button
		[disabled]="isFormValid.includes(false)"
		*ngIf="!isEditMode"
		(click)="createPackage()"
		mat-button
		class="w-full bg-gradient text-off-white rounded-[6px]"
	>
		{{ 'ACTIONS.SAVE' | translate }}
	</button>
	<button
		*ngIf="!isEditMode"
		(click)="navigate()"
		class="w-full border-[1px] text-dark-grey border-[#D9DBE9] rounded-[6px] py-[10px] text-font-14 mt-12px"
	>
		{{ 'ACTIONS.CANCEL' | translate }}
	</button>
</div>
<app-add-package-services
	[packageData]="packageData"
	*ngIf="addServiceMode"
	(emittedServices)="updateForm($event)"
	(addServiceMode)="addServiceMode = $event"
	(viewMode)="viewMode = $event"
></app-add-package-services>
